import { useRef } from "react";
import { BODY_WEIGHT, ESet, WeightLbs } from "../models/ESet";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

type Props = {
  weightLbs: WeightLbs;
  isDone: boolean;
  onChange: (weight: ESet['weightLbs']) => void
}

const BODY_WEIGHT_INDICATION = "B"

const ITEMS = [
  { label: "Lbs", value: 'lbs' },
  { label: "Bodyweight", value: BODY_WEIGHT_INDICATION }
]

const DEFAULT_WEIGHT_LBS = 0

function WeightInput({ weightLbs, onChange }: Props) {
  const isBodyWeight = weightLbs === BODY_WEIGHT
  const rawWeight = (isBodyWeight ? BODY_WEIGHT_INDICATION : weightLbs.toString());
  const inputRef = useRef<HTMLInputElement | null>(null)
  return (
    <label className="flex flex-row items-center gap-1 max-w-100">
      {!isBodyWeight &&
        <input
          ref={inputRef}
          className={`w-12 text-center border-dashed border-b-2 border-muted-foreground ${isBodyWeight ? "hidden" : ""}`}
          onFocus={(e) => {
            e.target.select();
          }}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.blur();
            }
          }}
          onChange={(e) => {
            const v = e.target.value;
            if (v === BODY_WEIGHT_INDICATION) {
              onChange(BODY_WEIGHT)
              return
            }
            const weight = parseFloat(e.target.value);
            if (!isNaN(weight)) {
              onChange(weight)
            }
          }} value={rawWeight} />
      }
      <Select value={isBodyWeight ? BODY_WEIGHT_INDICATION : "lbs"} onValueChange={(v) => {
        if (v === BODY_WEIGHT_INDICATION) {
          onChange(BODY_WEIGHT)
        } else {
          // to lbs
          onChange(DEFAULT_WEIGHT_LBS)
          // focus on the input
          setTimeout(() => {
            // TODO: hack to avoid the select from stealing focus back
            inputRef.current?.focus()
          }, 200)
        }
      }}>
        <SelectTrigger className="w-full max-w-48">
          <SelectValue />
        </SelectTrigger>
        <SelectContent>
          <SelectGroup>
            {ITEMS.map((item) => (
              <SelectItem key={item.value} value={item.value}>
                {item.label}
              </SelectItem>
            ))}
          </SelectGroup>
        </SelectContent>
      </Select>
    </label>
  )
}

export default WeightInput
